import { GenerateCartLinkScreen } from "./generate-cart-link.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const GenerateCartLinkRoutes: RouteDefinition[] = [
	{
		path: Paths.generateCartLink.path,
		element: <GenerateCartLinkScreen />,
		requiredPermissions: ["UserInAccountPermission_GenerateCartLinkAdmin_Modify"],
	},
];
